import gql from "graphql-tag";
import * as React from "react";

import type {AsyncApolloQueryResult} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import ApolloQuery from "#data-access/gql/apollo-query.tsx";

import type {
    studentListByClassCode,
    studentListByClassCodeVariables,
} from "./__graphql-types__/studentListByClassCode.ts";

type QueryResult = AsyncApolloQueryResult<
    studentListByClassCode,
    studentListByClassCodeVariables
>;

export const DATA_QUERY: GqlOperation<
    studentListByClassCode,
    studentListByClassCodeVariables
> = gqlOp(gql`
    query studentListByClassCode($classCode: String!) {
        joinByClassCodeInfo(classCode: $classCode) {
            id
            cacheId
            name
            signupCode
            descriptor
            includesCentrallyOwnedDistrictData
            classroomDistrictInfo {
                id
                emailDomains
            }
        }
    }
`);

type Props = {
    classCode: string;
    onCompleted?: (data?: studentListByClassCode) => void;
    children: (result: QueryResult) => React.ReactNode;
};

class StudentListByClassCodeQuery extends React.Component<Props> {
    render(): React.ReactNode {
        const {classCode, children, onCompleted} = this.props;
        return (
            <ApolloQuery
                query={DATA_QUERY}
                fetchPolicy="cache-first"
                variables={{classCode}}
                onCompleted={onCompleted}
            >
                {children}
            </ApolloQuery>
        );
    }
}

export default StudentListByClassCodeQuery;
